import React from 'react';
import { Link } from 'react-router-dom';

/*
 * The four-card handover, shared by /cmpx, /steadystride and /getstarted.
 *
 * It was pasted into three pages before this existed, which meant the label
 * corrections on 4 Sep ("Caseload" to "Clients and Studio", then "Cohorts and
 * consent" to "Research") had to be made in three places each. One component
 * means the next correction is made once.
 *
 * The labels name the CMPX sections a role is provisioned, not the persona.
 * Order is HR first: employers are the ICP, and this is a call to action rather
 * than a description of the product.
 */

const IconHR = () => (
    <svg width="34" height="34" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <rect x="4" y="7" width="24" height="18" rx="3" stroke="currentColor" strokeWidth="2" />
        <path d="M9 20v-5M16 20v-9M23 20v-3" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
);
const IconPerson = () => (
    <svg width="34" height="34" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <rect x="10" y="3" width="12" height="26" rx="3" stroke="currentColor" strokeWidth="2" />
        <path d="M14 7h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="16" cy="24" r="1.8" fill="currentColor" />
    </svg>
);
const IconPhysio = () => (
    <svg width="34" height="34" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <circle cx="13" cy="10" r="5" stroke="currentColor" strokeWidth="2" />
        <path d="M5 26c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M22 13l2.5 2.5L29 11" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
const IconResearch = () => (
    <svg width="34" height="34" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <circle cx="14" cy="14" r="9" stroke="currentColor" strokeWidth="2" />
        <path d="M21 21l7 7" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        <path d="M10 14h8M14 10v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const VIEWS = [
    { to: '/employers',        icon: <IconHR />,       label: 'Workforce reporting', role: 'HR and reward' },
    { to: '/individuals',      icon: <IconPerson />,   label: 'Your programme',      role: 'The person' },
    { to: '/physiotherapists', icon: <IconPhysio />,   label: 'Clients and Studio',  role: 'Physiotherapist' },
    { to: '/researchers',      icon: <IconResearch />, label: 'Research',            role: 'Researcher' },
];

const Signposts = ({ id = 'who', heading = 'Whose view do you need?', children }) => (
    <section className="tint" id={id}>
        <div className="wrap">
            <h2><span className="setup">{heading}</span></h2>
            <div className="povs">
                {VIEWS.map((v) => (
                    <Link className="pov" key={v.to} to={v.to}>
                        <span className="ic">{v.icon}</span>
                        <span className="lb">{v.label}</span>
                        <span className="ty">{v.role}</span>
                    </Link>
                ))}
            </div>
            {children}
        </div>
    </section>
);

export default Signposts;
